export const OPCConstant = {
  BYPASS_FAMILY: 'Installation Parts and Accessories',
  UPDATE_SUCCESS: 'Updated Successfully',
  UPDATE_FAILURE: 'Failed to Update',
  UPDATE_WARNING: 'Please fill all the required fields with Valid Data',
  DELETE_SUCCESS: 'Deleted Successfully',
  DELETE_FAILURE: 'Failed to Delete',
  CONFIRM_MESSAGE: 'Are you sure that you want to perform this action?',
  INVALID_IMAGE_UPLOAD: 'Invalid Image! Please upload an image (.png format) of minimum-maximum size as 10kb-100kb',
  PF_DELETE_FAILURE: 'There are Product Lines associated to this Product Family',
  PL_DELETE_FAILURE: 'There are Part Groups associated to this Product Line',
  PC_DELETE_FAILURE: 'There are Part Groups associated to this Part Category',
  PG_DELETE_FAILURE: 'There are Parts associated to this Part Group',
  P_DELETE_FAILURE: 'An Error Occured while deleting this Part',
  ADDED_SUCCESS: 'Added Successfully',
  ADDED_FAILURE: 'Failed to Add',
  VINTAGE_FAILURE: 'Vintage Start Date should be less than Vintage End Date'
};



// WEBPACK FOOTER //
// ./src/opc/opc-app/opc.const.ts